import { AgencySybTypeId } from '@app/models';
import { TrainType, TrainTypeId } from '@app/pcs/models';
import * as R from 'ramda';

type IsTrainType = (trainTypeId: number) => boolean;
export const isPassenger: IsTrainType = (trainTypeId: number) => trainTypeId === TrainTypeId.Passenger;

export const findTrainTypeById = (trainTypes, trainTypeId) => R.find(R.propEq('id', trainTypeId), trainTypes) as TrainType;

export const hasCargoTrainComposition: IsTrainType = (trainTypeId: number) => trainTypeId === TrainTypeId.Cargo || trainTypeId === TrainTypeId.Mixed;

type ResolveAgencySubTypeIds = (trainTypeId: number) => string[];
export const resolveAgencySubTypeIds: ResolveAgencySubTypeIds = R.cond([
  [R.equals(TrainTypeId.Cargo), R.always([AgencySybTypeId.Cargo, AgencySybTypeId.Oss])],
  [R.equals(TrainTypeId.Passenger), R.always([AgencySybTypeId.Passenger, AgencySybTypeId.Oss])],
  [R.equals(TrainTypeId.Locomotive), R.always([AgencySybTypeId.Cargo, AgencySybTypeId.Passenger, AgencySybTypeId.Oss])],
  [R.equals(TrainTypeId.Maintenance), R.always([AgencySybTypeId.Cargo, AgencySybTypeId.Oss])],
  [R.equals(TrainTypeId.Emergency), R.always([AgencySybTypeId.Cargo, AgencySybTypeId.Passenger, AgencySybTypeId.Oss])],
  [R.equals(TrainTypeId.Mixed), R.always([AgencySybTypeId.Cargo, AgencySybTypeId.Passenger, AgencySybTypeId.Oss])],
  [R.equals(TrainTypeId.Other), R.always([AgencySybTypeId.Cargo, AgencySybTypeId.Passenger, AgencySybTypeId.Oss])],
  [R.T, R.always([])]
]);
